import { LOGIN, LOGOUT, UPDATE_PROFILE } from '../actions.type';

export function loginSuccess(user) {
  return {
    type: LOGIN,
    user
  };
}

export function updateProfile(profile) {
  return {
    type: UPDATE_PROFILE,
    profile
  };
}

export function logout() {
  return {
    type: LOGOUT
  };
}



// WEBPACK FOOTER //
// ./src/redux/user/user.actions.js